import '../../css/base.css';
import WalkSandaig from './walkSandaig';
import WalkCorranCoastal from './walkCorranCoastal';
import WalkLochans from './walkLochans';
import WalkHighlandsGlenelg from './walkhighlandsGlenelg';

const Walks = () => {

  return (
    <div>
      <div className="row" style={{"marginBottom": "1rem"}}>

      <div className="col-12 col-md-6">
        <WalkSandaig />
      </div>
      <div className="col-12 col-md-6">
        <WalkCorranCoastal />
      </div>
      <div className="col-12 col-md-6">
        <WalkLochans />
      </div>
      <div className="col-12 col-md-6">
        <WalkHighlandsGlenelg />
      </div>
      </div>
    </div>
  );
}

export default Walks;